module.exports = __webpack_public_path__ + "static/shape_battles-224a6bfcfa9e8200d57e177aa8fce741.gif";